import { fileUrl } from "@/lib/api";

/**
 * Reusable avatar. Renders the uploaded photo (cookie-auth via fileUrl) if
 * `user.avatar_path` is set; otherwise falls back to the burgundy initial circle
 * the rest of the app has used since launch — so nothing regresses for members
 * who never upload a photo.
 *
 * Use this anywhere the codebase used to render an initial circle inline.
 */
export default function Avatar({
  user,
  size = 40,
  className = "",
  ring = false,
  testId,
}) {
  const name = user?.name || "·";
  const initial = name[0].toUpperCase();
  const path = user?.avatar_path || null;
  const px = `${size}px`;
  // Tailwind classes for text sizing scale roughly with diameter.
  const fontClass =
    size >= 96 ? "text-4xl"
    : size >= 64 ? "text-3xl"
    : size >= 48 ? "text-2xl"
    : size >= 36 ? "text-lg"
    : "text-base";

  const ringClass = ring ? "ring-2 ring-cream shadow" : "";
  const base = `rounded-full overflow-hidden flex items-center justify-center font-serif shrink-0 ${ringClass} ${className}`;

  if (path) {
    return (
      <span
        className={`${base} bg-cream-surface`}
        style={{ width: px, height: px }}
        data-testid={testId}
      >
        <img
          src={fileUrl(path)}
          alt={name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </span>
    );
  }
  return (
    <span
      className={`${base} bg-burgundy text-cream ${fontClass}`}
      style={{ width: px, height: px }}
      aria-label={name}
      data-testid={testId}
    >
      {initial}
    </span>
  );
}
